import React from 'react'

export const DashboardCtx = React.createContext({
  handleNotificationClick: () => {}
})
